module.exports = "div.barra-botoes {\n  padding: 0px;\n  text-align: right;\n  padding-right: 50px; }\n\ndiv.content-heading {\n  padding: 10px !important; }\n\ndiv.barra-titulo {\n  margin-top: 3px;\n  padding-left: 25px; }\n\n.barra-botoes-fixada {\n  position: absolute;\n  top: 20px;\n  z-index: 10;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/componentes/barra-botoes/barra-botoes.component.scss
// module id = ./src/app/shared/componentes/barra-botoes/barra-botoes.component.scss
// module chunks = main